import React from 'react';
import { useSelector } from 'react-redux';
import { seoStateSelector } from '@stencil/flights-seo-reducers/src/SRP/redux/selectors';
import SeoSrpCarousel from '../srp-card/seo-srp-carousel';
import ListForLinks from '@stencil/commonstories/src/components/Seo/list-for-links/list-for-links';

const SeoCheapFlightsLeft = props => {
  const seoState = useSelector(seoStateSelector);
  const { offers, domAirlines, popularSectors, topSectors } = seoState;

  return (
    <>
      <SeoSrpCarousel offers={offers} />
      {(domAirlines && (
        <ListForLinks title="Top Airlines" html={domAirlines.api_url} links={[]} isDweb={true} />
      )) ||
        null}
      {(popularSectors && (
        <ListForLinks title="Top Airlines" html={popularSectors.api_url} links={[]} isDweb={true} />
      )) ||
        null}
      {(topSectors && (
        <ListForLinks
          title="Top Domestic Routes"
          html={topSectors.api_url}
          links={[]}
          isDweb={true}
        />
      )) ||
        null}
    </>
  );
};

export default SeoCheapFlightsLeft;
